import { BasePanel } from "./BasePanel.js";

const bgPath = "/assets/vrUI/tipPanel/bg.png";

export class SystemTipPanel extends BasePanel {
  constructor(manager) {
    super(manager);
  }

  async init() {
    this.bgMap = await this.manager.loadManager.loadTexture(bgPath);

    this.container = this.uilib.createContainer({
      renderOrder: 1000000,
      color: 0xffffff,
      map: this.bgMap,
      opacity: 1,
      width: 0.8,
      height: 0.2,
      radius: 0.025,
      dragable: false,
    });
    this.container.position.y = 0.6;
    this.uilib.addUIToScene(this.container);
    this.container.hide();
    //container.scale.set(0.5, 0.5, 0.5);

    if (this.info) {
      this.show(this.info.str, this.info.time);
    }
  }

  show(str, time = 3000) {
    // 还未准备好，先缓存
    if (!this.container) {
      this.info = {
        str,
        time,
      };
      return;
    }

    if (this.settimeout && this.text) {
      clearTimeout(this.settimeout);
      this.uilib.removeUI(this.text);
      this.container.hide();
      this.settimeout = null;
    }

    this.text = this.uilib.createText({
      renderOrder: 1000001,
      text: str,
      textColor: 0x3d4146,
      textSize: 0.05,
      lineTextCount: 50,
      font: "bold",
      outlineWidth: 0.001,
      outlineColor: 0x3d4146,
    });
    this.text.position.z = 0.001;
    this.container.show();
    this.container.add(this.text);

    this.settimeout = setTimeout(() => {
      this.uilib.removeUI(this.text);
      this.container.hide();
      this.settimeout = null;
    }, time);
  }
}
